import { render, staticRenderFns } from "./history.vue?vue&type=template&id=241f712b&scoped=true"
import script from "./history.vue?vue&type=script&setup=true&lang=js"
export * from "./history.vue?vue&type=script&setup=true&lang=js"
import style0 from "./history.vue?vue&type=style&index=0&id=241f712b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241f712b",
  null
  
)

export default component.exports